import React from 'react'
import AppWrapper from '../../layout/AppWrapper'

export default function Error404() {
  return (
    <AppWrapper>
        <div style={{minHeight: '70vh'}} className='py-4 d-flex flex-column align-items-center justify-content-center'>
            <h1 style={{fontSize: '7rem', fontWeight: '900'}}>404</h1>
            <h3 className='fallback-header'>Page not found</h3>
            <p className='fallback-text'>The page you are looking for does not seem to exist</p>
        </div>
    </AppWrapper>
  )
}
